import { useMutation } from '@tanstack/react-query';
import { luckyDrawApiV2 } from '../../../lib/api/luckyDraw';

export const useRequestDownloadLuckyDrawParticipants = () => {
  return useMutation({
    mutationFn: (code: string) => luckyDrawApiV2.requestDownloadLuckyDrawParticipants(code),
  });
};
